import * as THREE from 'three';
import { Intersection, PointsMaterial, Raycaster } from 'three';
import { Line2 } from 'three/examples/jsm/lines/Line2.js';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry.js';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
import { LineSegments2 } from 'three/examples/jsm/lines/LineSegments2.js';
import { Font } from 'three/examples/jsm/loaders/FontLoader';
import { Fiko3DYazi } from './Fiko3DYazi';
import { FikoGrup } from './FikoGrup';
import { FikoSahne } from './FikoSahne';
import { FikoVektor3D } from './FikoVektor3d';
import { getCanvasResolution } from './FikoCanvasResolution';

export class Fiko3DYaziIsaretleyici extends FikoGrup {
    static anaYaziTipi: Font;
    yazi3d: Fiko3DYazi | THREE.Sprite; // Seçimli: 3D yazı veya sprite label
    yaziTipi: '3D' | 'Sprite' = 'Sprite'; // Yazı tipi seçimi
    sabitBoyut: boolean = true; // Sprite için sabit boyut kontrolü
    override type: any = "Fiko3DIsaretleyici";
    sagMenu: any[] = []; // Sağ menü yapılandırması
    private originalOnBeforeRender: ((renderer: THREE.WebGLRenderer, scene: THREE.Scene, camera: THREE.Camera, geometry: THREE.BufferGeometry, material: THREE.Material, group: THREE.Group) => void) | null = null; // Sprite boyut sabitleme için

    // 🚀 PERFORMANS: Event handler referansı - dispose için gerekli
    private _kontrolDegistiHandler: (() => void) | null = null;
    /** */
    pointGeom: THREE.BufferGeometry = new THREE.BufferGeometry().setFromPoints([new FikoVektor3D(0, 0, 0)]);
    point = new THREE.Points(this.pointGeom, this.sahne.anaGosterim.standartMaterialPointVertex.clone());
    /** */
    lineMaterial: LineMaterial = new LineMaterial({
        color: 0x000000,
        linewidth: 3, // in pixels - daha kalın
        vertexColors: false,
        //resolution:  // to be set by renderer, eventually
        dashed: true, // Catia tarzı kesikli çizgi
        dashScale: 0.5, // Kesik aralığı
        dashSize: 0.3, // Kesik boyutu
        depthTest: false,  // Derinlik testi yok - her zaman görünür
        depthWrite: false, // Derinlik buffer'a yazmaz - diğer objeleri etkilemez
        transparent: false,
        worldUnits: false,
    });
    lineGeometry: LineGeometry = new LineGeometry();
    line: LineSegments2 = new LineSegments2(this.lineGeometry, this.lineMaterial);
    /** */
    constructor(public override sahne: FikoSahne, isim?: string) {
        super(sahne);
        /** */
        this.lineGeometry.setPositions([0, 0, 0, 0, 0, -50]);

        const _res = getCanvasResolution(this.sahne?.anaGosterim?.sunucu);
        this.lineMaterial.resolution.set(_res.width, _res.height);

        this.line.computeLineDistances();
        this.line.scale.set(1, 1, 1);
        this.line.renderOrder = 999999999; // En üstte çizilsin (FikoEksen pattern'i)

        // Çizgi için materyal üzerinden depth kontrolü (renderer.state yok)
        (this.line.material as any).depthTest = false;
        (this.line.material as any).depthWrite = false;

        /** */
        this.point.material.size = 5;
        this.point.renderOrder = 999999999; // En üstte çizilsin (FikoEksen pattern'i)

        // Nokta için depth kontrolü
        this.point.material.depthTest = false;
        this.point.material.depthWrite = false;
        /** */
        // this.name = "Fiko3DIsaretleyici"
        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/bayrak.webp";

        // plane.translateZ(-50);
        // plane.rotation.set(Math.PI / 2, 0, Math.PI / 4);

        /** */
        // Seçimli yazı oluştur: default Sprite (Catia stili)
        this.yaziTipi = 'Sprite'; // Default olarak Sprite (kullanıcı isteği)
        this.yazi3d = this.createYaziObject(isim || "İşaretleyici");


        // var plane = new THREE.Mesh(new THREE.PlaneGeometry(this.yaziMesh.merkez.max["x"], this.yaziMesh.merkez.max["y"]), new THREE.MeshPhongMaterial({ specular: '#fff', fog: false, color: '#ff9a00' }))
        // console.log(this.yaziMesh.merkez);
        // this.yaziMesh.add(plane);

        this.yazi3d.translateZ(-50);
        this.yazi3d.rotation.set(Math.PI / 2, 0, Math.PI / 4);


        this.renderOrder = 999999999; // En üstte çizilsin (FikoEksen pattern'i)

        // Her frame'de depth test'i devre dışı bırak - agresif çözüm
        this.onBeforeRender = (renderer: any) => {
            renderer.state.setDepthTest(false);
            renderer.state.setDepthWrite(false);
        };

        this.onAfterRender = (renderer: any) => {
            renderer.state.setDepthTest(true);
            renderer.state.setDepthWrite(true);
        };


        this.merkezle()
        /** */
        this.ekle(this.point, this.line, this.yazi3d);

        // Sağ menü yapılandırması
        this.sagMenu = [
            {
                simge: null,
                baslik: "Gizle / Göster",
                tiklandi: () => {
                    this.visible = !this.visible;
                    this.sahne.anaGosterim.FikoYT.degisti.emit();
                    this.sahne.anaGosterim.ciz();
                }
            },
            {
                simgeYazi: "📍",
                baslik: this.getPozisyonBilgisi(),
                tiklandi: () => {
                    this.copyTextToClipboard(this.getPozisyonBilgisi());
                }
            },
            {
                tipi: "Ayraç"
            },
            {
                simge: "edit",
                baslik: "Yazıyı Düzenle",
                tiklandi: () => {
                    this.ciftTiklandi();
                }
            },
            {
                simge: "copy",
                baslik: "İşaretleyiciyi Kopyala",
                tiklandi: () => {
                    this.kopyala();
                }
            },
            {
                simge: "trash",
                baslik: "İşaretleyiciyi Sil '" + this.name + "'",
                tiklandi: () => {
                    this.sil();
                }
            }
        ];

        this.sahne.anaGosterim.ciz();
    }

    // Seçimli yazı object oluşturma
    createYaziObject(text: string): Fiko3DYazi | THREE.Sprite {
        if (this.yaziTipi === 'Sprite') {
            return this.createCatiaLabel(text);
        } else {
            // Default: 3D yazı
            return new Fiko3DYazi(this.sahne, text, text);
        }
    }

    // Catia stili label oluşturma (FikoEksen createLabel veya kendi metodumuz)
    createCatiaLabel(text: string): THREE.Sprite {
        let label: THREE.Sprite;

        // FikoEksen varsa onu kullan, yoksa kendi metodumuzu
        if (this.sahne && this.sahne.eksen && this.sahne.eksen.createLabel) {
            label = this.sahne.eksen.createLabel({
                text: text,
                textColor: '#000000',  // Siyah yazı
                backgroundColor: '#ffff99', // Sarı arka plan (catia stili)
                borderColor: '#000000',  // Siyah çerçeve
                borderWidth: 2,
                borderRadius: 4,
                fontSize: 24,
                fontFamily: 'Arial',
                padding: 8,
                shadow: true,
                shadowOptions: { blur: 2, offsetX: 1, offsetY: 1, color: 'rgba(0,0,0,0.3)' },
                scaleFactor: 0.01,
            });
        } else {
            // Kendi sprite oluşturma metodumuz
            label = this.createSpriteLabel(text);
        }

        label.renderOrder = 999999999; // En üstte çizilsin
        return label;
    }

    // Kendi sprite label oluşturma metodumuz (FikoEksen olmadığında)
    createSpriteLabel(text: string): THREE.Sprite {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;

        // Metin ayarları - daha kontrollü boyutlar
        const fontSize = 18;
        const padding = 12;
        const borderWidth = 2;
        const borderRadius = 4;

        ctx.font = `${fontSize}px Arial`;
        const textWidth = ctx.measureText(text).width;
        const textHeight = fontSize;

        // Max boyutlar kısıtlaması - çok uzun yazılar için
        const maxTextWidth = 200;
        const actualTextWidth = Math.min(textWidth, maxTextWidth);
        const width = actualTextWidth + padding * 2;
        const height = textHeight + padding * 2;

        // Canvas boyutlarını ayarla
        canvas.width = width;
        canvas.height = height;

        // Font ayarlarını tekrar yap (canvas boyutu değişince sıfırlanıyor)
        ctx.font = `${fontSize}px Arial`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        // Arka plan (sarı)
        ctx.fillStyle = '#ffff99';
        this.drawRoundedRect(ctx, 0, 0, width, height, borderRadius);
        ctx.fill();

        // Çerçeve (siyah)
        ctx.strokeStyle = '#000000';
        ctx.lineWidth = borderWidth;
        this.drawRoundedRect(ctx, 0, 0, width, height, borderRadius);
        ctx.stroke();

        // Gölge
        ctx.shadowColor = 'rgba(0,0,0,0.3)';
        ctx.shadowBlur = 2;
        ctx.shadowOffsetX = 1;
        ctx.shadowOffsetY = 1;

        // Metin (siyah) - uzun yazılar için otomatik kesme
        ctx.fillStyle = '#000000';
        if (textWidth > maxTextWidth) {
            // Metni kısalt
            const ellipsis = '...';
            const truncatedText = this.truncateText(ctx, text, maxTextWidth, ellipsis);
            ctx.fillText(truncatedText, width / 2, height / 2);
        } else {
            ctx.fillText(text, width / 2, height / 2);
        }

        const texture = new THREE.CanvasTexture(canvas);
        texture.needsUpdate = true;

        const material = new THREE.SpriteMaterial({
            map: texture,
            depthTest: false,
            transparent: true,
        });

        const sprite = new THREE.Sprite(material);

        // Daha orantılı scale - FikoEksen gibi
        const scaleFactor = 0.01; // FikoEksen ile aynı scaleFactor
        sprite.scale.set(width * scaleFactor, height * scaleFactor, 1);

        // Sabit boyut için scale değerlerini sakla
        (sprite as any)._originalScaleX = width * scaleFactor;
        (sprite as any)._originalScaleY = height * scaleFactor;

        // Sabit boyut kontrolü için kamera dinleyicisi
        // 🚀 PERFORMANS: Handler referansını tut - dispose için gerekli
        if (this.sabitBoyut && this.sahne?.anaGosterim?.aktifKontrol) {
            this._kontrolDegistiHandler = () => {
                const factor = (this.sahne.anaGosterim.aktifKamera.top - this.sahne.anaGosterim.aktifKamera.bottom) / this.sahne.anaGosterim.aktifKamera.zoom;
                const newScale = factor * 0.1; // FikoEksen ile aynı

                // Orijinal aspect ratio'yu koru
                sprite.scale.set(
                    (sprite as any)._originalScaleX * newScale,
                    (sprite as any)._originalScaleY * newScale,
                    1
                );
            };
            this.sahne.anaGosterim.aktifKontrol.addEventListener("change", this._kontrolDegistiHandler);
        }

        return sprite;
    }

    // Metni belirtilen genişliğe göre kesme
    private truncateText(ctx: CanvasRenderingContext2D, text: string, maxWidth: number, ellipsis: string): string {
        if (ctx.measureText(text).width <= maxWidth) {
            return text;
        }

        let truncated = text;
        while (ctx.measureText(truncated + ellipsis).width > maxWidth && truncated.length > 0) {
            truncated = truncated.slice(0, -1);
        }

        return truncated + ellipsis;
    }

    // Yuvarlak dikdörtgen çizme yardımcı metodu
    private drawRoundedRect(ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, radius: number) {
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
    }

    merkezle() {
        if (!this.yazi3d) {
            return;
        }

        if (this.yaziTipi === 'Sprite') {
            // Sprite'ı merkezle - FikoEksen'deki gibi
            this.yazi3d.position.set(-0.1, 0, -50); // X'te hafif sola kaydır
        } else {
            // 3D yazı merkezleme
            const yazi3d = this.yazi3d as Fiko3DYazi;
            if (yazi3d.yaziMesh) {
                yazi3d.position.setX(-yazi3d.merkez.x);
            }
        }
    }

    // Helper metodlar - güvenli özellik erişimi
    getYazi(): string {
        if (this.yaziTipi === 'Sprite') {
            return this.userData.yazi || this.name;
        } else {
            return (this.yazi3d as Fiko3DYazi).yazi;
        }
    }

    setYazi(text: string): void {
        if (this.yaziTipi === 'Sprite') {
            this.userData.yazi = text;
            // Sprite'ı yeniden oluştur
            const eskiYazi = this.yazi3d;
            this.yazi3d = this.createCatiaLabel(text);
            this.remove(eskiYazi);
            this.add(this.yazi3d);

            // Yeni sprite'ın visible olmasını sağla
            this.yazi3d.visible = this.visible;

            // Sabit boyut için callback'ı güncelle
            this.updateSabitBoyutCallback();
        } else {
            (this.yazi3d as Fiko3DYazi).yazi = text;
        }
        this.merkezle();

        // Three.js render'ı tetikle
        if (this.sahne && this.sahne.anaGosterim) {
            this.sahne.anaGosterim.ciz();
        }
      }

    updateSabitBoyutCallback(): void {
        // Eski callback'ı temizle
        if (this.originalOnBeforeRender) {
            this.onBeforeRender = this.originalOnBeforeRender;
        } else {
            this.onBeforeRender = null;
        }

        // Sabit boyut ise callback'ı ekle
        if (this.sabitBoyut && this.yaziTipi === 'Sprite') {
            this.originalOnBeforeRender = this.onBeforeRender;
            this.onBeforeRender = (renderer: THREE.WebGLRenderer, scene: THREE.Scene, camera: THREE.Camera, geometry: THREE.BufferGeometry, material: THREE.Material, group: THREE.Group) => {
                if (this.originalOnBeforeRender) {
                    this.originalOnBeforeRender(renderer, scene, camera, geometry, material, group);
                }

                // Sprite'ın scale'ini sabit tut - orijinal boyutuna geri getir
                if (this.yazi3d && this.yazi3d instanceof THREE.Sprite) {
                    const scaleFactor = 0.01; // Oluşturuldaki scaleFactor ile aynı
                    const canvas = (this.yazi3d.material as THREE.SpriteMaterial).map?.source?.data as HTMLCanvasElement;
                    if (canvas) {
                        const width = canvas.width * scaleFactor;
                        const height = canvas.height * scaleFactor;
                        this.yazi3d.scale.set(width, height, 1);
                    }
                }
            };
        }
    }

    // 🚀 PERFORMANS: Pre-allocated array for raycast filtering
    private static _raycastableChildren: THREE.Object3D[] = [];

    override raycast(raycaster: Raycaster, intersects: Intersection[]): void {
        // LineSegments2'leri filtrele (material.resolution hatası önlemek için)
        // 🚀 PERFORMANS: Static array kullan - allocation yok
        const raycastable = Fiko3DYaziIsaretleyici._raycastableChildren;
        raycastable.length = 0;
        for (let i = 0; i < this.children.length; i++) {
            if (this.children[i].type !== 'LineSegments2') {
                raycastable.push(this.children[i]);
            }
        }
        let kesisenler = raycaster.intersectObjects(raycastable, false);

        if (kesisenler.length > 0) {
            intersects.push({
                object: this,
                distance: kesisenler[0].distance,
                point: kesisenler[0].point,
                face: null,
                faceIndex: null,
                index: null,
                instanceId: this.id,
                //@ts-ignore
                yon: { x: this.xYon, y: this.yYon, z: this.zYon },
                altObje: kesisenler[0].object,
                grup: this,
                tiklandi: () => this.tiklandi(),
                ciftTiklandi: () => this.ciftTiklandi(),
                enUstte: true,
                secilebilir: true,
            });
        } else {
            return;
        }
    }
    async ciftTiklandi($event?) {
        // Dialog Core üzerinden aç (FikoEksen pattern'i)
        const { Fiko3dYaziIsaretleyiciComponent } = await import('./fiko-3dyazi-isaretleyici/fiko-3dyazi-isaretleyici.component');

        this.sahne.anaGosterim.DialogFiko.ac({
            bilesen: Fiko3dYaziIsaretleyiciComponent,
            parametreler: { isaretleyici: this },
            $event: $event,
            ayarlar: {
                baslik: 'Fiko 3D Yazı İşaretleyici',
                simgeResim: './simgeler/bayrak.webp'
            }
        });
    }

    tiklandi() {
        // console.log(" tek tiklandi", this);
    }

    override toJSON(): any {
        return {
            type: this.type,
            isim: this.name,
            uuid: this.uuid,
            position: this.position.toArray(),
            yazi: this.getYazi(),
            yaziTipi: this.yaziTipi,
            // 3D yazı özellikleri (sadece 3D ise)
            boyut: this.yaziTipi === '3D' ? (this.yazi3d as Fiko3DYazi).boyut : undefined,
            renk: this.yaziTipi === '3D' ? '#' + (this.yazi3d as Fiko3DYazi).renk.getHexString() : undefined,
            sabitBoyut: this.yaziTipi === '3D' ? (this.yazi3d as Fiko3DYazi).sabitBoyut : undefined,
            sabitYon: this.yaziTipi === '3D' ? (this.yazi3d as Fiko3DYazi).sabitYon : undefined,
            aciklama: this.userData.aciklama || ''
        };
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const _rslt = new Fiko3DYaziIsaretleyici(sahne, json.isim);
        _rslt.uuid = json.uuid;
        _rslt.parent = parent;

        if (json.position) {
            _rslt.position.fromArray(json.position);
        }

        // Yazı tipini ayarla
        if (json.yaziTipi) {
            _rslt.yaziTipi = json.yaziTipi;
        }

        if (json.yazi) {
            _rslt.setYazi(json.yazi);
        }

        // Sadece 3D yazı için özellikleri ayarla
        if (_rslt.yaziTipi === '3D') {
            const yazi3d = _rslt.yazi3d as Fiko3DYazi;

            if (json.boyut !== undefined) {
                yazi3d.boyut = json.boyut;
            }

            if (json.renk) {
                yazi3d.renk = new THREE.Color(json.renk);
            }

            if (json.sabitBoyut !== undefined) {
                yazi3d.sabitBoyut = json.sabitBoyut;
            }

            if (json.sabitYon !== undefined) {
                yazi3d.sabitYon = json.sabitYon;
            }
        }

        if (json.aciklama) {
            _rslt.userData.aciklama = json.aciklama;
        }

        _rslt.merkezle();

        return _rslt;
    }

    /** Pozisyon bilgisi string olarak döndürür */
    getPozisyonBilgisi(): string {
        return `Pozisyon: X:${this.position.x.toFixed(2)} Y:${this.position.y.toFixed(2)} Z:${this.position.z.toFixed(2)}`;
    }

    /** Yazıyı kopyala metodu */
    copyTextToClipboard(text: string): void {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(() => {
            }).catch(err => {
            });
        } else {
            // Fallback
            const textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        }
    }

    /** İşaretleyiciyi kopyalar */
    kopyala(): void {
        // Parent'ı Fiko3DIsaretleyiciler olarak cast et
        const parentIsaretleyiciler = this.parent as any;
        if (this.parent && parentIsaretleyiciler.ekleFikoIsaretci) {
            const kopya = parentIsaretleyiciler.ekleFikoIsaretci(this.getYazi() + " Kopya");
            if (kopya) {
                kopya.position.copy(this.position);
                kopya.setYazi(this.getYazi() + " Kopya");

                // 3D yazı özelliklerini kopyala
                if (this.yaziTipi === '3D') {
                    const yazi3d = this.yazi3d as Fiko3DYazi;
                    const kopyaYazi3d = kopya.yazi3d as Fiko3DYazi;
                    if (kopyaYazi3d) {
                        kopyaYazi3d.boyut = yazi3d.boyut;
                        kopyaYazi3d.renk = yazi3d.renk.clone();
                        kopyaYazi3d.sabitBoyut = yazi3d.sabitBoyut;
                        kopyaYazi3d.sabitYon = yazi3d.sabitYon;
                    }
                }

                this.sahne.anaGosterim.ciz();
                this.sahne.anaGosterim.FikoYT.degisti.emit();
            }
        }
    }

    /** İşaretleyiciyi siler */
    sil(): void {
        this.dispose(); // 🚀 PERFORMANS: Dispose çağır
        this.parent?.remove(this);
        this.sahne.anaGosterim.ciz();
        this.sahne.anaGosterim.FikoYT.degisti.emit();
    }

    /** 🚀 PERFORMANS: Memory leak önlemek için dispose metodu */
    dispose(): void {
        // Event listener'ı kaldır
        if (this._kontrolDegistiHandler && this.sahne?.anaGosterim?.aktifKontrol) {
            this.sahne.anaGosterim.aktifKontrol.removeEventListener("change", this._kontrolDegistiHandler);
            this._kontrolDegistiHandler = null;
        }

        // Geometry ve material temizle
        if (this.pointGeom) {
            this.pointGeom.dispose();
        }
        if (this.lineGeometry) {
            this.lineGeometry.dispose();
        }
        if (this.lineMaterial) {
            this.lineMaterial.dispose();
        }

        // Sprite texture temizle
        if (this.yazi3d instanceof THREE.Sprite) {
            const spriteMaterial = this.yazi3d.material as THREE.SpriteMaterial;
            if (spriteMaterial.map) {
                spriteMaterial.map.dispose();
            }
            spriteMaterial.dispose();
        }
    }
}